__turbopack_context__.v({
  "container": "highlight-icon-module__aOUxKG__container",
});
